import React, { PropsWithChildren, useState } from "react";
import Sidebar from "../Sidebar";
import Topbar from "../Header";

const DefaultLayout = ({ children }: PropsWithChildren) => {

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    // Toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    return (
        <div className="flex h-screen">
            {/* Sidebar */}
            <div className={`fixed inset-y-0 left-0 z-50 transform ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"} transition-transform duration-300 ease-in-out md:relative md:translate-x-0 md:w-64`}>
                <Sidebar />
            </div>

            {/* Main Content */}
            <div className="flex flex-col flex-grow">
                <Topbar toggleSidebar={toggleSidebar} />
                <div className="p-6 bg-gray-100 flex-grow">
                    {children}
                </div>
            </div>

            {/* Overlay for sidebar on mobile */}
            {isSidebarOpen && (
                <div
                    className="fixed inset-0 bg-black opacity-50 md:hidden"
                    onClick={toggleSidebar}
                ></div>
            )}
        </div>
    );
};

export default DefaultLayout;
